import { Alignment } from '../types';
// NOTE: all settings properties should have default value.
export var SEARCH_RESULTS_SETTINGS_DEFAULTS = {
    isSearchBarEnabled: true,
    searchBarPlaceholder: 'Search...',
    itemsPerPage: 10,
    isResultsMessageWithQuery: false,
    isResultsMessageWithNumber: true,
    isResultsEmptyMessageWithNumber: false,
    isResultsEmptyMessageWithQuery: false,
    resultsMenuAlignment: Alignment.Left,
    paginationAlignment: Alignment.Center,
};
export var SEARCH_RESULTS_SETTINGS_KEYS = Object.keys(SEARCH_RESULTS_SETTINGS_DEFAULTS);
//# sourceMappingURL=constants.js.map